// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Preu","colCheckbox":"styles_colCheckbox__e3TOj"};